import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-edd49a00"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "mr-2 non-selectable" }
const _hoisted_3 = { key: 1 }

import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useAnalytics } from '@/plugins/analytics';
import useCabinetStore from '@/store/CabinetStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'TopPanelUserMenu',
  setup(__props) {

const router = useRouter();
const rootStore = useStore();
const analytics = useAnalytics();
const { company, user } = useCabinetStore();

function logout() {
  const companyParams = {
    companyId: company.value?.id,
    companyType: company.value?.type,
  };
  rootStore
    .dispatch('auth/signOut')
    .then(() => router.push({ name: 'home' }))
    .finally(() => {
      analytics.handle('logoutSuccess', companyParams);
    });
}

return (_ctx: any,_cache: any) => {
  const _component_VPhone = _resolveComponent("VPhone")!
  const _component_VMenuArrow = _resolveComponent("VMenuArrow")!
  const _component_VMenuItem = _resolveComponent("VMenuItem")!
  const _component_VCard = _resolveComponent("VCard")!
  const _component_VMenu = _resolveComponent("VMenu")!

  return (_openBlock(), _createBlock(_component_VMenu, { class: "user mr-4 d-flex align-center" }, {
    activator: _withCtx(({ active, on: { click } }) => [
      _createElementVNode("div", {
        class: "d-flex align-center cursor-pointer",
        onClick: click
      }, [
        _createElementVNode("span", _hoisted_2, [
          (_unref(user).phone)
            ? (_openBlock(), _createBlock(_component_VPhone, {
                key: 0,
                value: _unref(user).phone
              }, null, 8, ["value"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(user).email), 1))
        ]),
        _createVNode(_component_VMenuArrow, {
          active: active,
          style: {"width":"12px"}
        }, null, 8, ["active"])
      ], 8, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_VCard, { class: "elevation-1 rounded-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_VMenuItem, { onClick: logout }, {
            default: _withCtx(() => [
              _createTextVNode("Выйти")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})